import { render, staticRenderFns } from "./job-class-add.vue?vue&type=template&id=fe46da36&scoped=true"
import script from "./job-class-add.vue?vue&type=script&lang=js"
export * from "./job-class-add.vue?vue&type=script&lang=js"
import style0 from "./job-class-add.vue?vue&type=style&index=0&id=fe46da36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe46da36",
  null
  
)

export default component.exports